import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      -	Mi estas tute senfortigita.
    </p>
    
    <p class="mb-3">
      -	Nu eltenu vi, almenaŭ por nelonge. Baldaŭ printempo…
    </p>
    
    <p class="mb-3">
      -	Ne. Por kia diablo mi venis ĉi tien? Mi ne plu volas. Mi deziras hejmen.
    </p>
    
    <p class="mb-3">
      -	Nu aŭskultu…
    </p>
    
    <p class="mb-3">
      -	Ne, mi revenos. Vi promesis al mi tutan mondon, kaj jen, ni eĉ najlon ne havas. Ni pereas poiomete, senhelpaj kaj malsataj…
    </p>
    
    <p class="mb-3">
      -	Nu komprenu, ni almenaŭ estas ja tute solaj. Neniu zorgas pri ni, ni ne plu vidas homojn kun iliaj abomenaj vizaĝoj… Ĉu gravas, kiel ni loĝas, se la plej grava estas, ke ni ne vidas homojn? 
    </p>
    
    <p class="mb-3">
      -	Sed…
    </p>
    
    <p class="mb-3">
      -	Memoru iliajn ridaĉojn, stultajn okulojn, kotan tuŝon de iliaj manoj, parolojn, parolojn!... Sen iu ajn vorto de vero, sincero, bonkoro…
    </p>
    
    <p class="mb-3">
      -	Ĉu vi opinias, ke vi estas pli bona ol ili? Ankaŭ vi estas homo, kaj same abomena por mi. Mi preferus vivi kun multaj, senrilataj al mi – min ja ili ne tuŝas, ne maltrankviligas. Sed vi – kiel abomena estas la vivo kun vi, ĉiam plendanta, pita, sendigna! Kiel vi tedegis al mi! Mi povus, plene povus malami homojn, se ili similas vin, nulaĵo! Neniun mi malamis dum mia vivo, nur vin; neniun homon krom vi!  
    </p>


    `
  )
}

const itemName = {
  esp: 'Dialogo de geedza paro en iu ermita kabano dum mielmonato'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}
export default item;